import { SimpleFieldComponent } from "../simpleField/simple-field-component"
import { validateEmailFields, ValidationResult } from "../../validation/api"

export class EmailComponent {

    private readonly emailFieldComponent: SimpleFieldComponent

    private readonly emailRepeatFieldComponent: SimpleFieldComponent

    constructor(documentObject: Document, validateImmediately: boolean) {
        this.emailFieldComponent = new SimpleFieldComponent(documentObject, "email", validateImmediately)
        this.emailRepeatFieldComponent = new SimpleFieldComponent(documentObject, "emailRepeat", validateImmediately)

        this.emailFieldComponent.registerEventListeners(() => this.validate())
        this.emailRepeatFieldComponent.registerEventListeners(() => this.validate())
    }

    async validate(): Promise<void> {
        try {
            const response = await validateEmailFields({
                email: this.emailFieldComponent.value,
                emailRepeat: this.emailRepeatFieldComponent.value
            })
            this.handleValidationResult(this.emailFieldComponent, response.email)
            this.handleValidationResult(this.emailRepeatFieldComponent, response.emailRepeat)
        } catch (e) {
            this.emailFieldComponent.clearErrors()
            this.emailRepeatFieldComponent.clearErrors()
        }
    }

    private handleValidationResult(component: SimpleFieldComponent, result: ValidationResult | undefined) {
        if (result) component.setValidationResult(result)
        else component.clearErrors()
    }
}
